import React from 'react';
import { RouteComponentProps } from 'react-router';
import { WithdrawGiftCreateContainer } from '../../epic/withdraw-gift-create';

export const Page: React.FC<RouteComponentProps> = () => {
  return <WithdrawGiftCreateContainer />;
};
